export class CookiebotVideoPlaceholder {
	/**
	 * Constructor
	 *
	 * @param {HTMLElement} element Element to block
	 * @return {void}
	 */
	constructor( element ) {
		this.element = element;

		const settings = window?.QalaGdprCompliance?.settings;

		if ( ! settings ) {
			return;
		}

		this.isEnabled = !! settings.isEnabled;
		this.isYoutubeEnabled = !! settings.isYoutubeEnabled;
		this.isVimeoEnabled = !! settings.isVimeoEnabled;
		this.videoContentBlockedMessage = settings.videoContentBlockedMessage;
	}

	/**
	 * Initialize the component
	 *
	 * @return {void}
	 */
	init() {
		if ( ! this.element ) {
			return;
		}

		if ( ! this.isEnabled ) {
			return;
		}

		this.checkElement( this.element );
	}

	/**
	 *
	 * @param {HTMLElement} element Element that is blocked by cookiebot
	 */
	checkElement( element ) {
		if ( ! this.isVimeo( element ) && ! this.isYoutube( element ) ) {
			return;
		}

		if ( this.isVimeo( element ) && ! this.isVimeoEnabled ) {
			return;
		}

		if ( this.isYoutube( element ) && ! this.isYoutubeEnabled ) {
			return;
		}

		const text = this.getText();
		const consentLevel = element.getAttribute( 'data-cookieconsent' );
		const optoutClass = `cookieconsent-optout-${ consentLevel }`;

		const placeholderElement = document.createElement( 'div' );
		placeholderElement.classList.add( 'qala-gdpr-compliance-video-placeholder' );
		placeholderElement.classList.add( optoutClass );

		const playButton = document.createElement( 'a' );
		playButton.className = 'qala-gdpr-compliance-video-placeholder__play';
		const url = element.getAttribute( 'data-cookieblock-src' );
		playButton.href = url;
		playButton.target = '_blank';

		const cookieElement = document.createElement( 'a' );
		cookieElement.href = 'javascript:Cookiebot.renew()';
		cookieElement.setAttribute( 'data-no-instant', '' );

		cookieElement.className = 'qala-gdpr-compliance-video-placeholder__cookiebot-link';
		cookieElement.innerHTML = text;

		placeholderElement.append( playButton );
		placeholderElement.append( cookieElement );

		// Insert just before the blocked element
		element.parentNode.insertBefore( placeholderElement, element );
	}

	/**
	 * Check if element is a Vimeo video
	 *
	 * @param {HTMLElement} element Element to check
	 * @return {boolean} True if element is a Vimeo video
	 */
	isVimeo( element ) {
		return element.getAttribute( 'data-cookieblock-src' ).includes( 'vimeo' );
	}

	/**
	 * Check if element is a Vimeo video
	 *
	 * @param {HTMLElement} element Element to check
	 * @return {boolean} True if element is a Vimeo video
	 */
	isYoutube( element ) {
		return element.getAttribute( 'data-cookieblock-src' ).includes( 'youtube' );
	}

	/**
	 * Get text for placeholder
	 *
	 * @return {string} Text for placeholder
	 */
	getText() {
		return this.videoContentBlockedMessage;
	}
}
